import _ from 'underscore';
import { BaseSurvey } from '../base-survey';
import { TransparentImageAnnotationSurveyView } from './view';

const surveyTriggerName = 'TransparentImageAnnotationSurveyTrigger';
const surveyCustomParamsName = 'TransparentImageAnnotationCustomParams';

export class TransparentImageAnnotationSurvey extends BaseSurvey {
  getSurveyName = () => 'TransparentImageAnnotationSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? 'eedaadb1-f55b-40c7-af92-0fddb9ab6ebf' : '4a17eef2-85be-49b9-8be6-b6f87916a9c0');

  validateTriggerCondition = () => {
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Start`);

    const isPilotEnabled = _.result(this.serverContext, ['Permissions', 'IsTransparentImageAnnotationEnabled']);

    if (!isPilotEnabled) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isPilotEnabled: ${isPilotEnabled}`);
      return false;
    }

    const isSurveyTriggerValid = _.result(window, ['survey', surveyTriggerName]);

    if (!isSurveyTriggerValid) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isSurveyTriggerValid: ${isSurveyTriggerValid}`);
      return false;
    }

    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Pass`);
    return true;
  };

  onSurveySubmit() {
    delete window.survey[surveyTriggerName];
    delete window.survey[surveyCustomParamsName];
  }

  onSurveyDismiss() {
    delete window.survey[surveyTriggerName];
    delete window.survey[surveyCustomParamsName];
  }

  getSurveyComponent = () => TransparentImageAnnotationSurveyView;

  getSurveyCustomParams = () => window.survey[surveyCustomParamsName];
}
